export const addOrReplace = <T>(array: T[], newItem: T, primaryKey: keyof T) => {
  const index = array.findIndex(
    (item) => item[primaryKey] === newItem[primaryKey]
  );

  return index === -1
    ? [...array, newItem]
    : array.map((item, i) => (i === index ? newItem : item));
};
